/* LandAirSea homepage behaviour, ported from r25-tech3 by theme/_port-homepage.py.
 * Each block is guarded: in the theme editor a merchant can hide or
 * reorder any section, so an element the original page could assume
 * was present may simply not exist. Unguarded, the first missing one
 * throws and every later block dies with it.
 *
 * Every section links this file so that hiding any one of them does
 * not take the behaviour down with it. That means the browser may
 * execute it several times -- duplicate <script src> tags each run --
 * so it latches on first run. Without the latch every slider would
 * bind its listeners ten times and advance ten slides per click.
 */
if (!window.__lasHomeInit) {
window.__lasHomeInit = true;

try {
(function () {
  var slider = document.getElementById('heroSlider');
  var slides = slider.querySelectorAll('.h9-slide');
  var dots = slider.querySelectorAll('.h9-dot');
  var current = 0;
  var timer = null;
  var INTERVAL = 6000;

  function show(n) {
    current = (n + slides.length) % slides.length;
    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.toggle('is-active', i === current);
      dots[i].classList.toggle('is-active', i === current);
      dots[i].setAttribute('aria-current', i === current ? 'true' : 'false');
    }
  }
  function start() {
    stop();
    timer = setInterval(function () { show(current + 1); }, INTERVAL);
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
  }
  for (var i = 0; i < dots.length; i++) {
    (function (n) {
      dots[n].addEventListener('click', function () { show(n); start(); });
    })(i);
  }
  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);
  show(0);
  start();
})();
} catch (e) { /* section not rendered */ }

try {
(function () {
  var slider = document.getElementById('hwSlider');
  var slides = slider.querySelectorAll('.hw-slide');
  var tabs = slider.querySelectorAll('.hw-tab');
  var current = 0;
  // false until the first show(0) has run, so the strip positions instantly on
  // load and only animates once the visitor presses something
  var started = false;

  function show(n) {
    current = (n + slides.length) % slides.length;
    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.toggle('is-active', i === current);
      tabs[i].classList.toggle('is-active', i === current);
      tabs[i].setAttribute('aria-selected', i === current ? 'true' : 'false');
    }
    // Keep the active tab in view WITHIN THE STRIP. Never scrollIntoView():
    // it walks up the ancestor chain and scrolls whatever it must to reveal
    // the element, the document included. r17 used it here and show(0) runs at
    // init, so on mobile the page loaded and threw the visitor 2,519px down
    // into this section. Moving strip.scrollLeft touches one scroll container
    // and cannot reach the page, which makes this right by construction
    // instead of by guarding the init case.
    var strip = tabs[current] && tabs[current].parentNode;
    if (strip && strip.scrollWidth > strip.clientWidth + 1) {
      var t = tabs[current];
      var target = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
      if (target < 0) { target = 0; }
      if (strip.scrollTo) {
        strip.scrollTo({left: target, behavior: started ? 'smooth' : 'auto'});
      } else {
        strip.scrollLeft = target;
      }
    }
  }
  for (var i = 0; i < tabs.length; i++) {
    (function (n) {
      tabs[n].addEventListener('click', function () { show(n); });
    })(i);
  }
  document.getElementById('hwPrev').addEventListener('click', function () { show(current - 1); });
  document.getElementById('hwNext').addEventListener('click', function () { show(current + 1); });
  show(0);
  started = true;
})();
} catch (e) { /* section not rendered */ }

}
